import React from 'react';
import { css } from '@emotion/react';
import { styled } from '@teko/ui';

const Td = styled.td`
  padding: 0 !important;
`;
const Content = styled.div(({ ml, mr }) => css`
    height: 1px;
    background-color: #e0e0e0;
    margin-left: ${ml}px;
    margin-right: ${mr}px;
  `);
const TableDivider = ({
  colCount,
  mr = 0,
  ml = 0
}) => {
  const content = [];
  for (let i = 0; i < colCount; i++) {
    content.push(/* @__PURE__ */ React.createElement(Td, {
      key: i
    }, /* @__PURE__ */ React.createElement(Content, {
      ml: i === 0 ? ml : 0,
      mr: i === colCount - 1 ? mr : 0
    })));
  }
  return /* @__PURE__ */ React.createElement("tr", null, content);
};

export { TableDivider };
